import { selectBusinessId } from 'modules/authentication'
import { useAppDispatch, useAppSelector } from 'modules/core'
import { usePusher } from 'modules/core/contexts/pusher.context'
import React, { useCallback, useEffect } from 'react'
import { fetchBusinessBilling } from '../slices/credit-balance.slice'
import { initializeRevenueCat } from '../slices/revenue-cat.slice'

export const SubscriptionPusherHandler: React.FC = () => {
  const dispatch = useAppDispatch()
  const { registerHandlers } = usePusher()
  const businessId = useAppSelector(selectBusinessId)

  const handleSubscriptionUpdated = useCallback(() => {
    dispatch(initializeRevenueCat())
    if (businessId) {
      dispatch(fetchBusinessBilling(businessId))
    }
  }, [dispatch, businessId])

  useEffect(() => {
    registerHandlers({
      onSubscriptionUpdated: handleSubscriptionUpdated,
    })
  }, [handleSubscriptionUpdated, registerHandlers])

  return null
}
